module.exports = __webpack_public_path__ + "img/ao.7d4bcc8.png";